import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import AppNavbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import LandingPage from './components/LandingPage';
import PoojaDetails from './components/PoojaDetails';
import CartPage from './components/CartPage';
import Footer from './components/Footer';
import AstrologyForm from './components/AstrologyForm';
import AdminView from './components/AdminView';
import MyBookings from './components/MyBookings';
import Profile from './components/Profile';
import LoginPage from './pages/LoginPage';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { updateMetaTags, pageMetaConfig } from './utils/metaTagManager';
import { addStructuredData, organizationSchema } from './utils/structuredData';
import { trackTotalVisit } from './utils/supabaseEdgeApi';
import { isMVP } from './config/features';

// Component to handle route-based meta tag updates
function RouteMetaUpdater() {
  const location = useLocation();

  useEffect(() => {
    // Map routes to meta configurations
    const routeToConfig = {
      '/': pageMetaConfig.home,
      '/about': pageMetaConfig.about,
      '/pooja-details': pageMetaConfig.poojaDetails,
      '/astrology': pageMetaConfig.astrology,
      '/cart': pageMetaConfig.cart,
      '/my-bookings': pageMetaConfig.myBookings,
      '/profile': pageMetaConfig.profile,
      '/login': pageMetaConfig.home, // Use home config as fallback
    };

    const currentPath = location.pathname;
    const metaConfig = routeToConfig[currentPath] || pageMetaConfig.home;

    // Update meta tags
    updateMetaTags(metaConfig);

    // Update structured data for homepage
    if (currentPath === '/') {
      addStructuredData(organizationSchema);
    }

    // Scroll to top on route change
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

function App() {
  const [category, setCategory] = useState('');
  const envType = process.env.REACT_APP_ENVIRONMENT_SETUP === 'local' || false;

  // Add organization schema on app load
  useEffect(() => {
    addStructuredData(organizationSchema);
    trackTotalVisit();
  }, []);

  return (
    <Router>
      <RouteMetaUpdater />
      <AuthProvider>
        <CartProvider>
          <AppNavbar setCategory={setCategory} isMVP={isMVP} />
         
          <Routes>
            <Route path="/" element={<Home category={category} />} />
            <Route path="/pooja-details" element={<PoojaDetails />} />
            <Route path="/cart" element={isMVP ? <Navigate to="/" replace /> : <CartPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/astrology" element={<AstrologyForm />} />
            <Route path="/my-bookings" element={isMVP ? <Navigate to="/" replace /> : <MyBookings />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/login" element={isMVP ? <Navigate to="/" replace /> : <LoginPage />} />
            {envType && <Route path="/dashboard" element={<AdminView />} />}
          </Routes>
          <Footer />
        </CartProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
